<template>
   <el-dialog custom-class="dialog-wrapper" :title="dialogTitle" :close-on-click-modal="false" 
      :modal-append-to-body="false" v-model="dialogVisible" width="600px">
      <div class="form-wrapper">
         <el-form label-width="120px" label-position="left" :model="formData" ref="formRef">
            <el-form-item label="校区选择">
               <div style="display: flex; align-items: center">
                  <el-select style="flex: 1; margin-right: 8px" placeholder="请选择校区" v-model="selectedCampus" filterable>
                     <el-option v-for="(item, index) in campusDataSource" :key="index" :label="item.label"
                        :value="item.value"></el-option>
                  </el-select>
                  <el-button @click="clickAddCampus">添加</el-button>
               </div>
               <div class="card-wrap">
                  <div v-for="item in formData.campusList" :key="item.value" class="card-item">
                     <span>{{ item.label }}</span>
                     <el-button type="text" icon="circle-close" @click="clickDeleteCampus(item.value)">
                     </el-button>
                  </div>
               </div>
               <div class="card-footer">
                  共计{{ formData.campusList.length }}个校区
               </div>
            </el-form-item>
         </el-form>
      </div>
      <template #footer>
         <div class="flex-row-center">
            <el-button @click="handleClose">取消</el-button>
            <el-button type="primary" @click="clickSave">确定</el-button>
         </div>
      </template>
   </el-dialog>
</template>

<script>
export default {
   name: 'LuFundCampusShield',
   props: {
      dialogTitle: {
         type: String,
         default: ''
      },
      dataSource: {
         type: Object,
         default: () => ({})
      },
      campusDataSource: {
         type: Array,
         default: () => []
      }
   },
   data() {
      return {
         dialogVisible: false,
         selectedCampus: '',
         formData: {
            campusList: []
         }
      }
   },
   mounted() {
      // 不再自己获取校区数据，完全依赖父组件传递
   },
   methods: {
      // 显示编辑对话框
      clickEdit() {
         this.dialogVisible = true;
         this.initFormData();
      },
      // 初始化表单数据
      initFormData() {
         if (this.dataSource && this.dataSource.resValue) {
            try {
               // 解析格式如 "90000,90001,90002" 的数据（只包含校区ID）
               const resValue = this.dataSource.resValue;
               if (resValue && typeof resValue === 'string' && resValue !== '0') {
                  // 按逗号分割校区ID
                  const campusIds = resValue.split(',');
                  const campusList = [];
                  
                  campusIds.forEach((campusId) => {
                     if (campusId && campusId.trim() && campusId !== '0') {
                        // 根据校区ID找到对应的校区信息，尝试字符串和数字两种类型匹配
                        const campusData = this.campusDataSource.find((item) => 
                           item.value === campusId.trim() || item.value === parseInt(campusId.trim())
                        );
                        if (campusData) {
                           campusList.push(campusData);
                        }
                     }
                  });
                  
                  this.formData.campusList = campusList;
               } else {
                  this.formData.campusList = [];
               }
            } catch (error) {
               console.log('陆基金校区屏蔽-解析数据失败:', error);
               this.formData.campusList = [];
            }
         } else {
            this.formData.campusList = [];
         }
         this.selectedCampus = '';
      },
      // 添加校区
      clickAddCampus() {
         if (!this.selectedCampus) {
            this.$util.errorMsg('请选择校区');
            return;
         }
         const existCampus = this.formData.campusList.find((item) => {
            return item.value === this.selectedCampus;
         });
         if (existCampus) {
            this.$util.errorMsg('该校区已添加');
            return;
         }
         const campusData = this.campusDataSource.find((item) => {
            return item.value === this.selectedCampus;
         });
         if (campusData) {
            this.formData.campusList = [...this.formData.campusList, campusData];
            this.selectedCampus = '';
         }
      },
      // 删除校区
      clickDeleteCampus(value) {
         const index = this.formData.campusList.findIndex((item) => item.value === value);
         if (index > -1) {
            this.formData.campusList.splice(index, 1);
         }
      },
      // 保存
      clickSave() {
         // 根据图片中的格式，将校区列表转换为校区ID的格式
         const campusIds = this.formData.campusList.map((item) => {
            return item.value; // 只保存校区ID
         });
         
         // 如果没有选择任何校区，传默认值0
         const resValue = campusIds.length > 0 ? campusIds.join(',') : '0';

         const param = {
            tag: this.dataSource.tag,
            key: this.dataSource.resKey,
            value: resValue
         };

         this.$http({
            url: this.$util.domain + "/adminapi/v1/tools/addOrUpdateConfig",
            method: "POST",
            dataType: "json",
            body: JSON.stringify(param)
         }).then((res) => {
            if (res.data.error === 10000) {
               this.$util.successMsg('保存成功');
               this.handleClose();
               this.$emit('refresh');
            } else {
               this.$util.errorMsg(res.data.message || '保存失败');
            }
         }).catch((error) => {
            console.log('陆基金校区屏蔽-保存失败:', error);
            this.$util.errorMsg('保存失败');
         });
      },
      // 关闭对话框
      handleClose() {
         this.dialogVisible = false;
         this.selectedCampus = '';
         this.formData.campusList = [];
      },
      
      // 根据校区ID获取校区名称
      getCampusNameById(campusId) {
         const campusData = this.campusDataSource.find((item) => item.value === campusId);
         return campusData ? campusData.label : campusId;
      },
      
      // 根据校区ID列表获取校区名称列表
      getCampusNamesByIds(campusIds) {
         if (!campusIds || campusIds.length === 0) {
            return [];
         }
         return campusIds.map(id => this.getCampusNameById(id));
      }
   }
}
</script>

<style scoped>
.card-wrap {
   width: 100%;
   height: 200px;
   margin: 8px 0 4px;
   padding: 10px;
   box-sizing: border-box;
   border: 1px solid #c0ccda;
   border-radius: 4px;
   overflow: auto;
   gap: 10px;
}

.card-footer {
   text-align: right;
   font-size: 14px;
   line-height: 1.5;
}

.card-item {
   display: inline-block;
   margin: 4px 4px;
   padding: 0px 4px;
   border: 1px solid #c0ccda;
   border-radius: 4px;
   font-size: 14px;
   line-height: 1.5;
}

.flex-row-center {
   display: flex;
   justify-content: center;
   align-items: center;
}

.margin-bottom-10 {
   margin-bottom: 10px;
}

</style>



// WEBPACK FOOTER //
// LuFundCampusShield.vue?116eb315